// Facturación por Cliente — per-client invoiced totals in the period, net of
// notas de crédito (each one subtracts in the period of its own date).
// Vendor = most-common created_by user across the client's invoices'
// linked reservations.
import supabase from "../../../supabase-client";

const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const invoicingByClientReport = {
  id: "invoicing-by-client",
  title: "Facturación por Cliente",
  description: "Facturación (con IVA) por cliente en el periodo, menos notas de crédito, con vendedor y desglose IVA.",
  category: "Finanzas",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
    // Client-side, over the loaded rows.
    { type: "search", key: "client_q", label: "Cliente", columns: ["client_name"] },
    { type: "facet", key: "vendor", label: "Asesor", column: "vendor" },
    { type: "facet", key: "client_type", label: "Tipo", column: "client_type",
      options: [{ label: "Empresa", value: "company" }, { label: "Persona", value: "customer" }] },
  ],
  summary: [
    { type: "sum", label: "Facturado Total", valueKey: "total", valueFormat: fmtMoney },
    { type: "groupBy", label: "Por Vendedor", key: "vendor", valueKey: "total", valueFormat: fmtMoney },
  ],
  columns: [
    {
      key: "client_type",
      label: "Tipo",
      format: (v) => (v === "company" ? "Empresa" : "Persona"),
    },
    { key: "client_name", label: "Cliente", width: 260, truncate: true },
    { key: "vendor", label: "Asesor" },
    { key: "subtotal", label: "Sin IVA", format: fmtMoney, exportType: "currency" },
    { key: "tax", label: "IVA", format: fmtMoney, exportType: "currency" },
    { key: "total", label: "Total", format: fmtMoney, exportType: "currency" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_invoicing_by_client", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
